//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
import TheButton from "../../components/general/TheButton.vue";
import storage from "~/assets/js/Storage";
import introJs from "intro.js/intro.js";
import "intro.js/introjs.css";
import User from "~/assets/js/User";
import getCachedUserData from "~/data/getCachedUserData";

export default {
  name: "PianificaSidebar",
  components: {
    TheButton,
  },
  data() {
    return {
      userData: null,
    };
  },
  computed: {
    markerTopPercentage() {
      let activePage = this.$store.state.pianificaSidebar.activePage;
      let activeSection = this.$store.state.pianificaSidebar.activeSection;
      let position =
        this.$store.state.pianificaSidebar[activePage].order.indexOf(
          activeSection
        );
      let sectionCount =
        Object.keys(this.$store.state.pianificaSidebar[activePage].sections)
          .length - 1;
      let percentage = (position * 100) / sectionCount;
      return percentage;
    },
  },
  created() {
    const data = storage.getClients();
    console.log(data);
    this.$store.commit("pianificaNavbar/setRestaurants", data);

    console.log(this.$store.state.pianificaNavbar.restaurants);
  },
  async mounted() {
    this.userData = await getCachedUserData(this.$config);
  },
  methods: {
    ...mapMutations({
      setActiveSection: "pianificaSidebar/setActiveSection",
      initAnalysis: "analysis/init",
      initRestaurant: "restaurant/init",
      initMenu: "menu/init",
      setMenuEdited: "menu/setEdited",
      setRestaurantEdited: "restaurant/setEdited",
    }),
    loadCustomer(e) {
      const clients = storage.getClients();

      const client = clients.find(
        (client) => client.restaurant_id == e.target.value
      );

      this.$localStore.set("activeRestaurantId", client.restaurant_id);
      this.$localStore.set("activeMenuId", client.menu.id);

      let restaurant = storage.getRestaurant(client.restaurant_id);
      this.$store.commit("restaurant/init", restaurant);

      let menu = storage.getMenu(client.menu.id);
      this.$store.commit("menu/init", menu);

      if (this.$route.path.includes("analisi")) {
        this.$router.push("/pianifica/locale");
      }
    },
    saveMenu() {
      this.$store.dispatch("menu/save");
    },
    saveRestaurant() {
      this.$store.dispatch("restaurant/save");
    },
    async requestAnalysis() {
      if (!storage.getMenuList().length) {
        this.$router.push({ path: "/pianifica/menu/nuovo" });
        return;
      }

      switch (this.$route.name) {
        case "pianifica-locale":
          if (this.$store.state.restaurant.edited) {
            let confirmed = await this.$store.dispatch(
              "exitPopup/getConfirmation"
            );

            // stay on current page
            if (confirmed === null) {
              return;
            }

            // save and change page
            if (confirmed) {
              await this.$store.dispatch("restaurant/save");
            } else {
              // delete changes
              let restaurantData = storage.getRestaurant(
                this.$store.state.restaurant.data.restaurant_id
              );
              this.initRestaurant(restaurantData);
              this.setRestaurantEdited(false);
            }
          }
          break;
        case "pianifica-menu":
          if (this.$store.state.menu.edited) {
            let confirmed = await this.$store.dispatch(
              "exitPopup/getConfirmation"
            );

            // stay on current page
            if (confirmed === null) {
              return;
            }

            // save and change page
            if (confirmed) {
              await this.$store.dispatch("menu/save");
            } else {
              // delete changes
              let menuData = storage.getMenu(
                this.$store.state.menu.data.menu_id
              );
              this.initMenu(menuData);
              this.setMenuEdited(false);
            }
          }
          break;
      }

      // empty analysis if menu is disabled
      if (this.$store.state.menu.data.disabled) {
        this.initAnalysis(null);
        this.$router.push("/pianifica/analisi");
      } else {
        // if analysis is in storage
        let analysis = storage.getAnalysis(
          this.$localStore.get("activeRestaurantId"),
          this.$localStore.get("activeMenuId")
        );

        if (analysis) {
          this.initAnalysis(analysis);
          this.$router.push("/pianifica/analisi");
        } else {
          // request analisys
          this.$store.dispatch("analysis/request");
        }
      }
    },
  },
};
